import { parseColumnChoice as parseChoice } from '../list/columnChoice'
import { COLUMN_KEYS, DEFAULT_COLUMN_KEYS } from './columns'

/** The competitions list's column choice, in this browser (`../list/columnChoice`). */
export const COLUMNS_STORAGE_KEY = 'ci.analytics.competitions.columns'

export const COLUMN_CHOICE = { storageKey: COLUMNS_STORAGE_KEY, keys: COLUMN_KEYS, defaults: DEFAULT_COLUMN_KEYS }

/** The stored choice, if it is one: known keys only, in display order, the competition always first. */
export function parseColumnChoice(raw: string | null): string[] | null {
  return parseChoice(raw, COLUMN_KEYS)
}

